import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupExclude: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="boolean-group-exclude" maskId="round-filled-radius-1-stroke-1.5-IconBooleanGroupExclude"><path fillRule="evenodd" clipRule="evenodd" d="M16 16H20C21.1046 16 22 15.1046 22 14V4C22 2.89543 21.1046 2 20 2H10C8.89543 2 8 2.89543 8 4V8H4C2.89543 8 2 8.89543 2 10V20C2 21.1046 2.89543 22 4 22H14C15.1046 22 16 21.1046 16 20V16ZM8 8H14C15.1046 8 16 8.89543 16 10V16H10C8.89543 16 8 15.1046 8 14V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupExclude;
